import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function FooterSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="w-full" data-id="element-9">
      {/* SECTION 13 - CTA FINAL */}
      <section className="py-24 bg-blue-900 text-white px-4 sm:px-6 lg:px-8 text-center relative overflow-hidden" data-id="element-10">
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-11">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-800/80 border border-blue-700 text-blue-100 font-bold text-xl mb-8 backdrop-blur-sm" data-id="element-12">
            🎾 PADEL 360
          </div>

          <h2 className="text-4xl md:text-5xl font-heading font-bold mb-8 uppercase leading-tight" data-id="element-13">
            El sistema de planificación N°1 para profesores de pádel argentinos.
          </h2>

          <p className="text-2xl text-yellow-400 font-heading italic mb-12" data-id="element-14">
            "Porque preparar una buena clase no debería costarte todas las
            noches de la semana."
          </p>

          <button onClick={scrollToPricing} className="w-full sm:w-auto bg-yellow-500 hover:bg-yellow-400 text-blue-950 text-2xl font-heading font-bold py-6 px-10 rounded-2xl shadow-2xl shadow-yellow-500/20 transition-all hover:scale-105 flex items-center justify-center gap-3 uppercase mx-auto mb-10" data-id="element-15">
            💪 QUIERO MI PADEL 360 AHORA
          </button>

          <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-blue-200 font-medium" data-id="element-16">
            <span className="flex items-center gap-2" data-id="element-17">
              <ShieldCheck className="w-5 h-5" data-id="element-18" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-2" data-id="element-19">
              <Lock className="w-5 h-5" data-id="element-20" /> Pago seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-21">
              <CreditCard className="w-5 h-5" data-id="element-22" /> Tarjetas · Transferencia ·
              Mercado Pago
            </span>
          </div>
        </div>
      </section>

      {/* SECTION 14 - FOOTER */}
      <footer className="bg-blue-950 text-blue-200/60 py-12 px-4 sm:px-6 lg:px-8 text-center" data-id="element-23">
        <div className="max-w-7xl mx-auto" data-id="element-24">
          <div className="text-2xl font-heading font-bold text-white mb-6" data-id="element-25">
            🎾 PADEL 360™
          </div>

          <div className="flex flex-wrap justify-center gap-6 mb-8 font-medium" data-id="element-26">
            <a href="#" className="hover:text-white transition-colors" data-id="element-27">
              📧 contacto@padel360.com.ar
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-28">
              📲 @padel360.ar
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-29">
              🌐 www.padel360.ar
            </a>
          </div>

          <p className="text-sm border-t border-blue-900 pt-8" data-id="element-30">
            © PADEL 360™ 2024 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </footer>
    </div>;
}